import axios from '@/utils/request'
import base from './base'
import qs from 'qs'

// 获取审核规则配置（未指定国家时返回国家列表 + 默认配置）
export function kycConfigGetByCountry(ruleType, countryCode) {
  const params = { ruleType: ruleType || undefined, countryCode: countryCode || undefined }
  return axios.post(`${base.url}/business/kycConfig/getByCountry`, qs.stringify(params))
}
// 保存审核规则配置
export function kycConfigSave(data) {
  return axios.post(`${base.url}/business/kycConfig/save`, JSON.stringify(data), { headers: { 'Content-Type': 'application/json' } })
}
// 删除国家审核规则配置
export function kycConfigDelete(ruleType, countryCode) {
  return axios.post(`${base.url}/business/kycConfig/delete`, qs.stringify({ ruleType, countryCode }))
}
// 自定义触发场景列表
export function kycSceneList() { return axios.post(`${base.url}/business/kycConfig/scene/list`) }
// 新增或更新自定义触发场景
export function kycSceneSave(data) {
  return axios.post(`${base.url}/business/kycConfig/scene/save`, JSON.stringify(data), { headers: { 'Content-Type': 'application/json' } })
}
// 删除自定义触发场景
export function kycSceneDelete(id) { return axios.post(`${base.url}/business/kycConfig/scene/delete`, qs.stringify({ id })) }
